<template>
  <div class="userList">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" @click="addUser" v-if="isHavePermission('userManage:create')">添加用户</Button>
      <vxe-button icon="vxe-icon--refresh" @click="getList" style="margin-left: 20px;">刷新</vxe-button>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>
    <div class="finance-header" style="display: flex; flex-wrap: wrap;margin-bottom: 10px;">
      <div class="finance-span">
        <label>注册手机号</label>
        <vxe-input
            v-model="searchFormData.loginName"
            placeholder="输入手机号"
        ></vxe-input>
      </div>
      <div class="finance-span">
        <label>实名认证状态</label>
        <vxe-select
            v-model="searchFormData.authStatus"
            :options="authStatusType"
            placeholder="全部"
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>会员类型</label>
        <vxe-select
            v-model="searchFormData.vipStr"
            :options="vipType"
            placeholder="全部"
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>身份类型</label>
        <vxe-select
            v-model="searchFormData.tagsStr"
            :options="userCategoryType"
            placeholder="全部"
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>用户来源</label>
        <vxe-select
            v-model="searchFormData.sourceTypes"
            :options="sourceTypeOption"
            placeholder="全部"
            multiple
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>账号类型</label>
        <vxe-select
            v-model="searchFormData.isTester"
            :options="testerOption"
            placeholder="全部"
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>账号状态</label>
        <vxe-select
            v-model="searchFormData.state"
            :options="accStateOption"
            placeholder="全部"
        ></vxe-select>
      </div>
      <div class="finance-span">
        <label>注册时间</label>
        <DatePicker
            type="date"
            v-model="searchFormData.createTimeBegin"
            placeholder="选择时间"
            style="width: 200px"
        ></DatePicker>
        -
        <DatePicker
            type="date"
            v-model="searchFormData.createTimeEnd"
            placeholder="选择时间"
            style="width: 200px"
        ></DatePicker>
      </div>
      <div class="finance-span">
        <label>申请注销时间</label>
        <DatePicker
            type="date"
            v-model="searchFormData.logoutApplyTimeBegin"
            placeholder="选择时间"
            style="width: 200px"
        ></DatePicker>
        -
        <DatePicker
            type="date"
            v-model="searchFormData.logoutApplyTimeEnd"
            placeholder="选择时间"
            style="width: 200px"
        ></DatePicker>
      </div>
      <div class="finance-span">
        <label>个人姓名</label>
        <Select
            v-model="searchUserName"
            clearable
            filterable
            prefix="ios-arrow-down"
            style="width: 300px"
            :remote-method="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeywordClient',5,1)"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'userNameOptions')"
            @on-clear="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeywordClient',5,1)"
            placeholder="输入姓名"
        >
          <Option
              v-for="option in userNameOptions"
              :value="option.text"
              :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
      </div>
      <div class="finance-span">
        <label>企业名称</label>
        <Select
            v-model="searchCompName"
            clearable
            filterable
            prefix="ios-arrow-down"
            style="width: 300px"
            :remote-method="(file) => remoteMethod(file,'compNameOptions','baseUserSign','queryUserSignKeyword',2,2)"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'compNameOptions')"
            @on-clear="(file) => remoteMethod(file,'compNameOptions','baseUserSign','queryUserSignKeyword',2,2)"
            placeholder="输入企业名称"
        >
          <Option
              v-for="option in compNameOptions"
              :value="option.text"
              :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
      </div>

      <div class="finance-span" style="margin-left: auto;">
        <Button type="primary" icon="ios-search" @click="search" style="border-radius: 5px;">搜索</Button>
        <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
      </div>
    </div>
    <vxe-table
        stripe
        class="table-style common-shadow"
        highlight-current-row
        align="center"
        highlight-hover-row
        :loading="loading"
        :data="userList"
        resizable
        @sort-change="sortChangeEvent"
    >
      <vxe-table-column field="id" title="序号" width="150">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
          <Dropdown trigger="click" style="margin-left: 20px"
                    v-if="
                  isHavePermission('userManage:auditAuth') ||
                  isHavePermission('userManage:cancelauth') ||
                  isHavePermission('userManage:auditDriverAuth') ||
                  isHavePermission('userManage:cancelDriverAuth') ||
                  isHavePermission('baseUserAuth:auditAuth') ||
                  isHavePermission('userManage:changePhone') ||
                  isHavePermission('userManage:vip') ||
                  isHavePermission('userManage:updateUserPass')||
                  isHavePermission('userManage:updateUserPayPass')||
                  isHavePermission('userManage:logout')
                "
                    transfer>
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left: 70px">
              <div style="display: flex; flex-direction: column">
                <Button class="button-gengduo" @click="authUserInfo(row)"
                        v-if="row.authStatus !== 3 && isHavePermission('userManage:auditAuth')">实名认证审核
                </Button>
                <Button class="button-gengduo" @click="cancelauthUserInfo(row)"
                        v-if="row.authStatus === 3 && isHavePermission('userManage:cancelauth')">取消实名认证
                </Button>
                <Button class="button-gengduo" @click="auditDriverAuth(row)"
                        v-if="row.tagsStr && row.tagsStr.indexOf('司机') > -1 && row.identityStatus !== 3 && isHavePermission('userManage:auditDriverAuth')">
                  司机身份认证
                </Button>
                <Button class="button-gengduo" @click="cancelDriverAuth(row)"
                        v-if="row.tagsStr && row.tagsStr.indexOf('司机') > -1 && row.identityStatus === 3 && isHavePermission('userManage:cancelDriverAuth')">
                  取消身份认证
                </Button>
                <Button class="button-gengduo" @click="changePhone(row)"
                        v-if="isHavePermission('userManage:changePhone')">变更手机号
                </Button>
                <Button class="button-gengduo" @click="openVip(row)" v-if="isHavePermission('userManage:vip')">会员管理
                </Button>
                <Button class="button-gengduo" @click="editUserPassword(row)"
                        v-if="isHavePermission('userManage:updateUserPass')">修改账户密码
                </Button>
                <Button class="button-gengduo" @click="showEditPayPassword(row)"
                        v-if="isHavePermission('userManage:updateUserPayPass')">修改支付密码
                </Button>
                <!--                <Button class="button-gengduo" @click="commitBaseUserSignType(row)" v-if="isHavePermission('userManage:changeUserType')">-->
                <!--                  {{ row.isTester === 1 ? '账号变更为用户' : '账号变更为内部' }}-->
                <!--                </Button>-->
                <Button class="button-gengduo" style="color: red" @click="commitLogout(row)"
                        v-if="row.state !== 4 && isHavePermission('userManage:logout')">
                  注销用户
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="loginName" min-width="180" title="注册手机号" show-overflow>
        <template slot-scope="{ row }">
          <span @click="userInfo(row)"
                :style="row.isSystemPhone === 1 ? 'cursor: pointer;color:red;':'cursor: pointer; color: #2d8cf0'">{{
              isHavePermission('userManage:loginName') ? row.loginName : geTel(row.loginName)
            }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="nickName" min-width="140" title="昵称" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.nickName ? row.nickName : geTel(row.loginName) }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="starLv" min-width="140" title="星级" show-overflow>
        <template slot-scope="{ row }">
          <span @click="setRate(row)" style="cursor: pointer">{{ row.starLv }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="realName" min-width="140" title="姓名" show-overflow></vxe-table-column>
      <vxe-table-column field="authStatus" min-width="180" title="实名状态" show-overflow>
        <template slot-scope="{ row }">
          <span style="display: inline-block; margin-left: 10px; cursor: pointer; color: #f59a23">{{
              authStatus(row)
            }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="vipStr" min-width="140" title="会员类型" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.vipStr }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="tagsStr" min-width="180" title="身份类型" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.tagsStr }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="sourceType" min-width="180" title="用户来源" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.sourceType | sourceType }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="isTester" min-width="180" title="账号类型" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.isTester === 1 ? '内部' : '用户' }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="state" min-width="180" title="账号状态" show-overflow>
        <template slot-scope="{ row }">
          <span :style="stateColor(row.state)" @click="changeState(row)">{{ row.state | state }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="phoneStatus" min-width="180" title="号码状态" show-overflow>
        <template slot-scope="{ row }">
          <span :style="row.isSystemPhone === 1 ? 'color:red;':''">{{ phoneStatus(row) }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="authTime" min-width="180" title="认证时间" show-overflow remote-sort>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.authTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createTime" min-width="180" title="注册时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="logoutApplyTime" min-width="180" title="申请注销时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.logoutApplyTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="current"
        :page-size.sync="pageSize"
        :total="userTotal"
        @page-change="change"
    ></vxe-pager>
    <!-- 修改密码 -->
    <vxe-modal v-model="editPasswordModal" width="600" height="320" title="修改账户密码" destroy-on-close>
      <vxe-form
          ref="passwordFrom"
          title-align="right"
          title-width="110"
          :data="userPasswordData"
          :rules="formRules2"
          style="margin-top: 20px; padding-right: 50px"
          @submit="submitPassword"
      >
        <vxe-form-item title="注册手机号" field="regisiterNum" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="userPasswordData.regisiterNum"
                disabled
                placeholder="请输入手机号"
                @input="$refs.passwordFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="登录密码" field="password" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="userPasswordData.password"
                type="password"
                placeholder="必填（密码长度为6位字母和数字组合）"
                @input="$refs.passwordFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="确认密码" field="newPassword" span="24">
          <template v-slot="scope">
            <vxe-input
                type="password"
                v-model="userPasswordData.newPassword"
                placeholder="再次输入密码"
                @input="$refs.passwordFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button status="primary" style="width: 140px; border-radius: 0px" @click="cancelSubmit">取消</vxe-button>
          <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 0px">保存</vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
    <edit-pay-password ref="editPayPassword"></edit-pay-password>
    <vxe-modal v-model="isShowChangePhone" title="变更手机号" width="500" height="300" position="center" destroy-on-close>
      <change-phone ref="changePhone" :isUser="true" @afterChange="getList"
                    @close="isShowChangePhone = false"></change-phone>
    </vxe-modal>
    <vxe-modal v-model="rateVisible" title="星级" width="300" height="200" position="center" destroy-on-close>
      <rate-view ref="rateView" @afterChange="changeRate" @close="rateVisible = false"></rate-view>
    </vxe-modal>
    <vxe-modal v-model="registerVisible" title="注册" width="600" height="350" position="center" destroy-on-close>
      <register-user ref="registerUser" @afterSave="afterRegister" @close="registerVisible = false"></register-user>
    </vxe-modal>
    <vxe-modal v-model="userInfoModal" width="1450" height="800" position="center" title="查看用户信息" destroy-on-close>
      <user-center :userId="userId" ref="userCenter"></user-center>
    </vxe-modal>
    <vxe-modal v-model="vipModal" width="900" height="650" position="center" title="查看会员管理" @close="closeVip"
               destroy-on-close>
      <vip-manage ref="vipManage"></vip-manage>
    </vxe-modal>
  </div>
</template>
<script>
import ChangePhone from "@/views/newUser/ChangePhone";
import EditPayPassword from "@/components/common/EditPayPassword";
import getAuthOrization from "@/mixin/getAuthOrization";
import $C from "@/consts";
import $api from "@/apiProvider";
import {hideLoading, isEmpty} from "@/utils/util";
import md5 from "js-md5";
import {apiPost} from "@/utils/api";
import Auth from "@/utils/auth";
import RateView from "@/views/newUser/RateView";
import RegisterUser from "@/views/newUser/RegisterUser";
import UserCenter from "@/components/userManage/UserCenter";
import moment from "moment";
import VipManage from "@/components/userManage/VipManage";

export default {
  components: {ChangePhone, EditPayPassword, RateView, RegisterUser, UserCenter, VipManage},
  mixins: [getAuthOrization],
  data() {
    const newPwdValid = ({cellValue}) => {
      if (this.userPasswordData.password != null && this.userPasswordData.password != "") {
        if (this.userPasswordData.newPassword !== this.userPasswordData.password) {
          this.isTrue2 = false;
          return Promise.reject(new Error("两次输入密码不一致"));
        } else {
          this.isTrue2 = true;
        }
      }
    };
    return {
      loading: false,
      rateVisible: false,
      isShowChangePhone: false,
      registerVisible: false,
      userInfoModal: false,
      vipModal: false,
      listQuery: {
        page: 1,
        rows: 10,
        userType: 1,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      },
      current: 1,
      pageSize: 10,
      userTotal: 50,
      editFormData: {},
      userPasswordData: {
        id: null,
        password: null,
        userName: null,
      },
      userPasswordDataCopy: {},
      formRules2: {
        userName: [{required: true, message: "请输入名称"}],
        password: [
          // { required: true, message: "请输入密码" },
          {min: 6, message: "密码长度为至少6个字符"},
        ],
        newPassword: [
          // { required: true, message: "请再输入密码" },
          {validator: newPwdValid},
        ],
      },
      editPasswordModal: false,
      searchFormData: {
        username: null,
        salesManName: null,
        compName: null,
        linkMan: null,
        linkPhone: null,
        authStatus: null,
        identityStatus: null,
        createUser: null,
        realName: null,
        time: null,
        userCategory: null,
        hasFile: null,
        regisiterNum: null,
        hasBusinessFile: null,
        authSource: null
      },
      authStatusType: $C.AUDIT_STATUS.options,
      authSourceType: [{
        label: '全部',
        value: null
      }, {
        label: '平台',
        value: 1
      },
        {
          label: '法大大',
          value: 2
        },
        {
          label: '网易',
          value: 3
        }
      ],
      phoneStatusOptions: [
        {
          label: '全部',
          value: null
        },
        {
          label: '空号',
          value: 0
        },
        {
          label: '正常',
          value: 1
        },
        {
          label: '停机',
          value: 2
        },
        {
          label: '无记录',
          value: 3
        },
        {
          label: '沉默号',
          value: 4
        },
        {
          label: '风险号',
          value: 5
        }
      ],
      regisiterNumStateType: [
        {
          label: '全部',
          value: null
        },
        {
          label: '系统号',
          value: -1
        },
        {
          label: '空号',
          value: 0
        },
        {
          label: '正常',
          value: 1
        },
        {
          label: '停机',
          value: 2
        },
        {
          label: '无记录',
          value: 3
        },
        {
          label: '沉默号',
          value: 4
        },
        {
          label: '风险号',
          value: 5
        }
      ],
      sourceTypeOption: [
        {
          label: '全部',
          value: null
        },
        {
          label: '主动注册',
          value: 2
        },
        {
          label: '后台添加',
          value: 1
        },
        {
          label: '用户邀请',
          value: 3
        },
        {
          label: '微信公众号',
          value: 4
        },
        {
          label: '微信小程序',
          value: 5
        },
        {
          label: '代客户创建',
          value: 6
        }],
      testerOption: [
        {
          label: '全部',
          value: null
        }, {
          label: '用户',
          value: 0
        },
        {
          label: '内部',
          value: 1
        }],
      accStateOption: [{
        label: '全部',
        value: null
      },
        {
          label: '启用',
          value: 1
        }, {
          label: '禁用',
          value: 2
        }, {
          label: '待注销',
          value: 3
        }, {
          label: '已注销',
          value: 4
        }],
      vipType: [{
        label: '全部',
        value: null
      }, {
        label: '普通会员',
        value: '普通会员'
      },
        {
          label: '黄金会员',
          value: '黄金会员'
        },
        {
          label: '白金会员',
          value: '白金会员'
        },
        {
          label: '钻石会员',
          value: '钻石会员'
        }],
      userCategoryMap: new Map(),
      userCategoryData: {
        options: [],
      },
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ], // 业务类型选择框
      userList: [],
      userId: null,
      searchLoading: false,
      searchUserName: null,
      userNameOptions: [],
      searchCompName: null,
      compNameOptions: [],
    }
  },
  filters: {
    sourceType(val) {
      if (val === 2) {
        return '主动注册';
      }
      if (val === 1) {
        return '后台添加';
      }
      if (val === 3) {
        return '用户邀请';
      }
      if (val === 4) {
        return '微信公众号';
      }
      if (val === 5) {
        return '微信小程序';
      }
      if (val === 6) {
        return '代客户创建';
      }
    },
    state(val) {
      if (val === 0) {
        return '禁用';
      }
      if (val === 1) {
        return '启用';
      }
      if (val === 2) {
        return '禁用';
      }
      if (val === 3) {
        return '待注销';
      }
      if (val === 4) {
        return '已注销';
      }
    },
  },
  mounted() {
    this.getList();
    this.getDicUserCategoryList();
  },
  methods: {
    sortChangeEvent(sort) {
      if (sort.order == null) {
        this.listQuery.orderBy = 2
        this.listQuery.isDesc = null
      } else {
        this.listQuery.isDesc = sort.order === 'desc' ? 1 : 0
        if (sort.field === 'authTime') {
          this.listQuery.orderBy = 13;
        }
      }
      this.search();
    },
    stateColor(val) {
      if (val === 0) {
        return 'color:red;cursor: pointer;';
      }
      if (val === 1) {
        return 'color:green;cursor: pointer;';
      }
      if (val === 2) {
        return 'color:red;cursor: pointer;';
      }
      if (val === 3) {
        return '';
      }
      if (val === 4) {
        return 'color:red;cursor: pointer;';
      }
    },
    closeVip() {
      this.getList();
    },
    geTel(tel) {
      let reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    openVip(row) {
      this.vipModal = true;
      this.$nextTick(() => {
        this.$refs.vipManage.setId(row.userIdApp);
      })
    },
    changeRate() {
      this.rateVisible = false;
      this.getList();
    },
    afterRegister() {
      this.registerVisible = false;
      this.getList();
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType, moduleType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getSearchList(query, options, url, path, columnType, moduleType);
      } else {
        this[options] = [];
      }
    },
    async getSearchList(query, options, url, path, columnType, moduleType) {
      let params = {
        columnType: columnType,
        moduleType: moduleType,
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    search() {
      this.listQuery.page = 1;
      this.current = 1;
      this.getList();
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    changeState(row) {
      if (this.isHavePermission('userManage:changeState')) {
        if (row.state === 0) {
          this.$XModal.confirm("您确定要启用么？").then(type => {
            if (type === "confirm") {
              this.enableOrDisable(row, 1);
            }
          });
        }
        if (row.state === 1) {
          this.$XModal.confirm("您确定要禁用吗？").then(type => {
            if (type === "confirm") {
              this.enableOrDisable(row, 2);
            }
          });

        }
        if (row.state === 2) {
          this.$XModal.confirm("您确定要启用吗？").then(type => {
            if (type === "confirm") {
              this.enableOrDisable(row, 1);
            }
          });
        }
        if (row.state === 4) {
          this.$XModal.confirm("您确定要重新启用么？").then(type => {
            if (type === "confirm") {
              this.enableOrDisable(row, 1);
            }
          });
        }
      }
    },
    async enableOrDisable(row, type) {
      let data = {
        userId: row.id,
        status: type,
      };
      let res = await $api.baseUserSign.request("enableOrDisable", data);
      if (res.status === 1) {
        this.getList();
        this.$XModal.message({message: `操作成功！`});
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitLogout(row) {
      this.$XModal.confirm("您确定要注销吗？").then(type => {
        if (type === "confirm") {
          this.logoutUser(row);
        }
      });
    },
    async logoutUser(row) {
      let data = {
        id: row.id,
      };
      let res = await $api.baseUserSign.request("logoutUser", data);
      if (res.status === 1) {
        this.getList();
        this.$XModal.message({message: `操作成功！`});
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    userInfo(row) {
      this.userId = row.id;
      this.userInfoModal = true;
    },
    addUser() {
      this.registerVisible = true;
    },
    setRate(row) {
      this.rateVisible = true;
      this.$nextTick(() => {
        this.$refs.rateView.setRate(row);
      })
    },
    reset() {
      this.searchFormData = {};
      this.searchUserName = null;
      this.searchCompName = null;
    },
    changePhone(row) {
      this.isShowChangePhone = true;
      this.$nextTick(() => {
        this.$refs.changePhone.setUpdate(row);
      })
    },
    editUserPassword(row) {
      this.userPasswordData = {};
      this.userPasswordData.regisiterNum = row.loginName;
      this.userPasswordData.id = row.id;
      this.editPasswordModal = true;
    },
    showEditPayPassword(row) {
      this.$refs.editPayPassword.showModal(row.loginName, row.id);
    },
    authUserInfo(row) {
      this.$XModal.confirm("该操作将把该用户变为认证状态").then((type) => {
        if (type === "confirm") {
          this.commitAuthUser(row);
        }
      });
    },
    async commitAuthUser(row) {
      let self = this;
      let res = await $api.gcdUser.request("queryUserInfoClientDetail", {id: row.id});
      if (res.status === 1) {
        if (res.data.idcardBackUrl === null ||
            res.data.idcardBackUrl === "" ||
            res.data.idcardFrontUrl === null ||
            res.data.idcardFrontUrl === "" ||
            res.data.idcardNum === null ||
            res.data.realName === null
        ) {
          this.$XModal.alert({
            message: "资料不全，请先上传认证资料",
            status: "error",
          });
          return;
        }


        let param = {
          auditUserId: parseInt(Auth.getAuth().id),
          auditStatus: 3,
          userIdClient: row.id,
        };

        this.commitauthTwo(param);

        self.$forceUpdate();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async commitauthTwo(formData) {
      var self = this;
      let res = await $api.authUser.request("auditAuthPerson", formData);
      if (res.status === 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "认证成功",
        });
        self.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitBaseUserSignType(row) {
      this.$XModal.confirm("该操作将把" + (row.isTester === 1 ? '账号变更为用户' : '账号变更为内部')).then((type) => {
        if (type === "confirm") {
          this.editBaseUserSignType(row);
        }
      });
    },
    async editBaseUserSignType(row) {
      let res = await $api.gcdUser.request("editBaseUserSignType", {
        id: row.id,
        state: row.isTester === 1 ? 2 : 1
      });
      if (res.status === 1) {
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelauthUserInfo(row) {
      this.$XModal.confirm("该操作将取消用户认证").then((type) => {
        if (type === "confirm") {
          this.commitCancelAuthUser(row);
        }
      });
    },
    async commitCancelAuthUser(row) {
      var self = this;
      var param = {
        userIdClient: row.id,
        remark: "您的认证已失效",
      };
      let res = await $api.authUser.request("cancelAuth", param);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    auditDriverAuth(row) {
      this.$XModal.confirm("该操作将认证该用户的司机身份").then((type) => {
        if (type === "confirm") {
          this.commitDriver(row);
        }
      });
    },
    async commitDriver(row) {
      let self = this;
      let res = await $api.gcdUser.request("queryUserInfoClientDetail", {id: row.id});
      if (res.status === 1) {
        if (res.data.drivingCardFrontUrl == null ||
            res.data.drivingCardFrontUrl == "" ||
            res.data.drivingCardSubpageUrl == null ||
            res.data.drivingCardSubpageUrl == ""
        ) {
          this.$XModal.alert({
            message: "资料不全，请先上传认证资料",
            status: "error",
          });
          return;
        }
        this.commitAuthDriver(row);
        self.$forceUpdate();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async commitAuthDriver(row) {
      var self = this;
      var xxx = {
        userIdClient: row.id,
        identityStatus: 3,
        type: 1,
      };
      let res = await $api.authUser.request("auditDriverAuth", xxx);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    cancelDriverAuth(row) {
      this.$XModal.confirm("该操作将取消司机身份认证").then((type) => {
        if (type === "confirm") {
          this.commitCancelAuthDriver(row);
        }
      });
    },
    async commitCancelAuthDriver(row) {
      let self = this;
      let xxx = {
        userIdClient: row.id,
        remark: "您的认证已失效",
      };

      let res = await $api.authUser.request("cancelDriverAuth", xxx);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    authStatus(row) {
      let val = row.authStatus;
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          if (row.authSource === 1) {
            return "已认证(平台)";
          } else if (row.authSource === 2) {
            return "已认证(法大大)";
          } else if (row.authSource === 3) {
            return "已认证(网易)";
          } else {
            return "已认证";
          }
        }
        if (val === 4) {
          return "已失效";
        }
      } else {
        return "未认证";
      }
    },
    phoneStatus(row) {
      if (row.isSystemPhone === 1) {
        return '系统号'
      } else {
        if (row.regisiterNumState === 0) {
          return '空号'
        }
        if (row.regisiterNumState === 1) {
          return '正常'
        }
        if (row.regisiterNumState === 2) {
          return '停机'
        }
        if (row.regisiterNumState === 3) {
          return '无记录'
        }
        if (row.regisiterNumState === 4) {
          return '沉默号'
        }
        if (row.regisiterNumState === 5) {
          return '风险号'
        }
      }
    },
    async changeStatus(id, state) {
      let res = await apiPost("api/auth/", "baseUserSign/editRegisterNumState", {
        id: id,
        regisiterNumState: state
      });
      if (res.status === 1) {
        this.$Message.success('操作成功');
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    change(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
    },
    getDicUserCategoryList() {
      let self = this;
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictCode, item.dictText);
            });
            // self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryData.options));
          });
    },
    getList() {
      this.loading = true;
      let data = Object.assign({}, this.listQuery);
      let obj = this.searchFormData;
      Object.keys(obj).forEach((key) => {
        data[key] = obj[key];
      });
      if (obj.createTimeBegin && obj.createTimeEnd) {
        data.createTimeBegin = moment(obj.createTimeBegin).valueOf();
        data.createTimeEnd = moment(obj.createTimeEnd).valueOf() + 86399999; // 结束时间
      } else {
        data.createTimeBegin = null;
        data.createTimeEnd = null;
      }
      if (obj.logoutApplyTimeBegin && obj.logoutApplyTimeEnd) {
        data.logoutApplyTimeBegin = moment(obj.logoutApplyTimeBegin).valueOf();
        data.logoutApplyTimeEnd = moment(obj.logoutApplyTimeEnd).valueOf() + 86399999; // 结束时间
      } else {
        data.logoutApplyTimeBegin = null;
        data.logoutApplyTimeEnd = null;
      }

      if (this.searchUserName) {
        data.realName = this.searchUserName;
      } else {
        data.realName = null;
      }
      if (this.searchCompName) {
        data.compName = this.searchCompName;
      } else {
        data.compName = null;
      }

      $api.gcdUser.queryRegisiterNumUserList
          .POST({
            data,
          })
          .then((response) => {
            if (response.status === 1) {
              let res = response.data;
              res.rows.map(i => {
                i.showUserCategory = this.userCategoryMap.get(i.userCategory);
              })
              this.userList = res.rows;
              this.userTotal = res.total;
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: response.message ? response.message : "接口异常",
                status: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    submitPassword() {
      let self = this;
      if (
          (this.userPasswordData.password != null && this.userPasswordData.password != "") &&
          (this.userPasswordData.newPassword == null || this.userPasswordData.newPassword == "")
      ) {
        this.$XModal.alert({
          message: "请确认密码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let reg = /((^[0-9]{6,})|(^[a-z]{6,})|(^[A-Z]{6,}))$/;
      if (reg.test(this.userPasswordData.password)) {
        this.$XModal.alert({
          message: "密码强度过低，请重新设置密码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      this.copyPasswordTemp();
      let data = this.userPasswordDataCopy;
      new Promise((resolve, reject) => {
        $api.gcdUser.updateUserPassModel
            .POST({
              data,
            })
            .then((res) => {
              if (res.status == 1) {
                this.$Message["success"]({
                  background: true,
                  content: "更新成功",
                });
                this.editPasswordModal = false;
                this.getList();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
                this.loading = false;
              }
              resolve();
            })
            .catch(function (er) {
              hideLoading();
              console.log(er.response.data.message);
              self.$XModal.alert({
                message: er.response.data.message ? er.response.data.message : "接口异常",
                status: "error",
              });
              return;
            });
      });
    },
    cancelSubmit() {
      this.editPasswordModal = false;
      this.editUserInfoModal = false;
    },
    copyPasswordTemp() {
      this.userPasswordDataCopy = {};
      this.userPasswordDataCopy.id = this.userPasswordData.id;
      if (this.userPasswordData.password == null || this.userPasswordData.password == "") {
        this.userPasswordDataCopy.password = md5("666888");
      } else {
        this.userPasswordDataCopy.password = md5(this.userPasswordData.password);
      }
    },
  }
}
</script>